import React from 'react'
import styled from 'styled-components'
import {Button} from 'startlibs/lib/components'
import {getColor} from 'startlibs/lib/lib'

const FirstStepsPage = styled.div `
  .need-help {
    margin-top: 2rem;
  }
`

export const FirstStepsGuide = styled.div `
  padding: 4rem 1rem;
  text-align: center;
  background-color: rgba(0,0,0,0.05);
  border-radius: 8px;
  h2 {
      margin: 0 auto 3rem;
      font-size: 19px;
      line-height: normal;
      max-width: 350px;
  }
  p {
      font-size: 14px;
      margin: 0 auto 1.5rem;
  }
  .horos-download-button {
      margin-bottom: 0.5rem;
      min-width: 16rem;
  }
  .download-message {
    font-size: 11px;
    color: rgba(0,0,0,0.5);
  }
  .screenshot-image {
    width: 100%;
    max-width: 580px;
    margin: 4rem auto 2rem;
  }
`

export class FirstSteps extends React.PureComponent {

  render() {
    return <FirstStepsPage className="content edit-profile">
      <div className="profile-header">
        <h1>First steps</h1>
      </div>
      <FirstStepsGuide>
        <div className="guide-content">
          <h2>To create a report or share a study please launch Horos on macOS</h2>
          <Button.a highlight href="horos://" className="horos-download-button">Launch Horos</Button.a>
          <div className="download-message">Do not have Horos App installed yet? <a className="link nowrap" target="_blank" href="https://horosproject.org/download-horos/">Download here</a></div>
          <img className="screenshot-image" alt="instructions" src="/public/firststeps-screenshot.png"/>
        </div>
      </FirstStepsGuide>
      <p className="need-help"><b>Need help?</b> We have a dedicated team for all questions regarding Horos Cloud. Contact us at <a className="link" href="mailto:support@horosproject.org">support@horosproject.org</a> or call us at <b>(800) 501 - 1537</b>.</p>
    </FirstStepsPage>
  }

}



// WEBPACK FOOTER //
// ./src/javascripts/public/FirstSteps.jsx